import { render, staticRenderFns } from "./wImage.vue?vue&type=template&id=a1c49954&scoped=true&"
import script from "./wImage.vue?vue&type=script&lang=js&"
export * from "./wImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c49954",
  null
  
)

export default component.exports